import {} from "moment";
import { parseUtcToLocal, toUtcString } from "@/utils/dateFormatter";
import { getAvailablePickupDates, getAvailableDropoffDates } from "@/services/shipments_new";
export async function getAvailablePickup(shipmentId, startDate) {
    if (!shipmentId) {
        return {
            availableDates: [],
            restrictedDays: [],
        };
    }
    try {
        const response = await getAvailablePickupDates(shipmentId, startDate ? toUtcString(startDate) : null);
        // transform dates string to Moment objects
        const availableDates = response?.dates?.map((date) => parseUtcToLocal(date)) ?? [];
        const restrictedDays = response?.restrictedDays ?? [];
        return { availableDates, restrictedDays };
    }
    catch (error) {
        console.error(error);
        return {
            availableDates: [],
            restrictedDays: [],
        };
    }
}
export async function getAvailableDropoff(shipmentId, pickupDate) {
    if (!shipmentId || !pickupDate) {
        return {
            availableDates: [],
            restrictedDays: [],
        };
    }
    try {
        const response = await getAvailableDropoffDates(shipmentId, pickupDate ? toUtcString(pickupDate) : null);
        // transform dates string to Moment objects
        const availableDates = response?.dates?.map((date) => parseUtcToLocal(date)) ?? [];
        const restrictedDays = response?.restrictedDays ?? [];
        return { availableDates, restrictedDays };
    }
    catch (error) {
        console.error(error);
        return {
            availableDates: [],
            restrictedDays: [],
        };
    }
}
